import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { EffectCreative, Pagination, Navigation, Autoplay } from "swiper/core";
import { 
    Box, HStack,
    Heading, Center,
    Hide
} from '@chakra-ui/react';
import ProjectBlock from '../modules/ProjectBlock';
import ChakraIcon from "../elements/ChakraIcon";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-flip";
import "swiper/css/navigation";
import "../../theme/Project.css"
import { useTheme } from '@chakra-ui/react';
import { BsFillCaretLeftFill, BsFillCaretRightFill} from "react-icons/bs";
import project1 from '../../assets/images/project1.jpg'
import project2 from '../../assets/images/project2.png'
import project3 from '../../assets/images/project3.png'
import project4 from '../../assets/images/project4.png'
import project5 from '../../assets/images/project5.jpg'
import project6 from '../../assets/images/project6.png'

SwiperCore.use([Pagination]);
SwiperCore.use([Navigation]);
SwiperCore.use([Autoplay]);

export default function Project(){
    const navigationPrevRef = React.useRef(null);
    const navigationNextRef = React.useRef(null);

    const theme = useTheme();
    
    
    const projects = [
        // the image ratio should be 3:2
        {
            text : "Traffic Light Recognition Assistance ",
            defaultText : "An Android app, built on React Native, utilizes Huawei's ModelArts and OBS to assist visually impaired users in detecting traffic lights. It received an Honorable Mention in the Huawei Cloud APAC 2022.",
            link: "https://github.com/ayaan278/Traffic-Recognition",
            image: project1
        }, 
        {
            text: "QuickGrade",
            defaultText: "A web app based on Django backend framework which utilizes NLP methods from NLTK library and sentence embedding from Tensorflow which grades the exam papers of students for the teachers automatically.",
            link: "https://youtu.be/AJyIaeSjcUI?si=C8RKw4Vy1sGDKeEj",
            image: project2
        },
        {
            text :"QR Code Reader", 
            defaultText: "A QR Code Reader extension for Google Chrome. It was built on React, using zxing-js library with Bootstrap. It has 4000+ users now.",
            link: "https://chrome.google.com/webstore/detail/qr-code-reader/ogidhdapceihieacnnopijooamfceepd/related?hl=en&authuser=0",
            image: project3
        },
        {
            text: "Unicab",
            defaultText: "A platform for the students of the University to book a cab for their daily commute, the matching algorithm matches student in nearby area going to the class in same time together. It was built on React Native, with NodeJS backend with Azure cloud and MYSQL database.",
            link: "https://youtu.be/kMa0IuTAKRM",
            image: project4
        },
        {
            text :"SAS Travels and Tourism ", 
            defaultText: "A Travel and Tourism website for a local travel agency. It was built on React, with ChakraUI. ",
            link: "http://sas-travels.com/",
            image: project5
        }, 
        {
            text :"IT Society Website", 
            defaultText: "A website for the IT Society of my university. It was built on React, with ChakraUI. ",
            link: "https://itsociety.rocks/",
            image: project6
        }, 
    ]

    
    return(
        <Box id="project" p={{ base: "0.5em", md: "1em", lg: "2em" }} 
        bg={theme.colors.text} align='center'
        w='100%'>
            <Heading fontSize={{ base: "32px", md: "36px", lg: "36px" }}
                    fontWeight={600}
                    fontFamily={theme.font.secondary}
                    color={theme.colors.primary}
                    py={'0.3em'} >Some Projects I did.</Heading>

            <HStack align={'center'} w="100%"  >
                    <Swiper 
                        slidesPerView={1}
                        spaceBetween={10}
                        modules={[EffectCreative, Pagination, Navigation]}
                        navigation={{
                        prevEl: navigationPrevRef.current,
                        nextEl: navigationNextRef.current,
                        }}
                        pagination={{
                            el: '.custom-pagination',
                            clickable: true,
                          }}
                          
                        breakpoints={{
                            800: {
                              slidesPerView: 2,
                              spaceBetween: 20,
                            },
                            1024: {
                              slidesPerView: 2,
                              spaceBetween: 20,
                            },
                          }}
                        onBeforeInit={(swiper) => {
                        swiper.params.navigation.prevEl = navigationPrevRef.current;
                        swiper.params.navigation.nextEl = navigationNextRef.current;
                        }}
                        autoplay={{
                        delay: 10000, // autoplay each image for 5 seconds
                        disableOnInteraction: false, // enable autoplay to continue after user interaction
                        }}
                        className="mySwiper"
                        style={{
                            width: "100%",
                            justifyContent: "center",
                            textAlign: "center",
                            alignItems: "center",
                            height: "100%"
                          }}
                    >
                        <Center>
                        {projects.map((project, index) => (
                            <React.Fragment key={index}>
                                <SwiperSlide>
                                <HStack
                                    py={'1em'}
                                    color="white"
                                    zIndex="2"
                                    display= "flex"
                                    border = {'hidden'} 
                                    justifyContent={'center'}
                                    alignItems={'center'}
                                    px={{base: '0em',md: '0.5em',lg: '0.5em'}}
                                >
                                    <ProjectBlock 
                                        text={project.text} 
                                        defaultText={project.defaultText}
                                        link={project.link}
                                        image={project.image}
                                    />
               
                                    </HStack>
                                </SwiperSlide>
                            </React.Fragment>
                        ))}
                        </Center>
                        <Hide breakpoint='(max-width: 800px)'>
                            <ChakraIcon
                                ref={navigationPrevRef}
                                name={<BsFillCaretLeftFill />}
                                flag={1}
                            />
                            <ChakraIcon 
                                ref={navigationNextRef} 
                                name={<BsFillCaretRightFill/>} 
                            />
                        </Hide>
                        <Box className="custom-pagination"
                         ></Box>
                    </Swiper>
            </HStack>
        </Box>

    );
}
